<template>
  <div class="mainContainer">
    <div class="nav">
      <div class="navContainer" style="width: 210px">
        <p>委托商：</p>
        <el-input v-model="entrustIpt" size="mini" style="width:150px" placeholder="请输入委托商名称"/>
      </div>
      <div class="navContainer">
        <p>类型：</p>
        <el-select v-model="typeIpt" size="mini" filterable style="width:150px" placeholder="请选择">
          <el-option v-for="item in typeOption" :key="item.id" :label="item.type_name" :value="item.id"/>
        </el-select>
      </div>
      <div class="navContainer" style="width: 230px">
        <p>企业性质：</p>
        <el-select v-model="enterIpt" size="mini" filterable style="width:150px" placeholder="请选择">
          <el-option v-for="item in enterOption" :key="item.id" :label="item.classaName" :value="item.id"/>
        </el-select>
      </div>
      <div class="navContainer" style="width: 230px">
        <p>操作类型：</p>
        <el-select v-model="operationIpt" size="mini" filterable style="width:150px" placeholder="请选择">
          <el-option v-for="item in operationOption" :key="item.label" :label="item.label" :value="item.value"/>
        </el-select>
      </div>
      <div class="navContainer">
        <p>状态：</p>
        <el-select v-model="stateIpt" size="mini" filterable style="width:150px" placeholder="请选择">
          <el-option v-for="item in stateOption" :key="item.label" :label="item.label" :value="item.value"/>
        </el-select>
      </div>
      <div class="navBtn">
        <el-button size="small" class="searchBtn" @click="searchBtn">查询</el-button>
        <el-button size="small" class="resetBtn" @click="resetBtn">重置</el-button>
      </div>
    </div>
    <div class="content">
      <div class="tableContainer">
        <el-table
          v-loading="tableLoad"
          :data="TableDatas"
          style="width: 100%"
          border
          stripe
          :header-cell-style="{color:'#3B3B3B','font-size':'13px','height':'48px',background:'#E8E8E8'}"
          :cell-style="{'color':'#7F7F7F','font-size':'13px','height':'52px',}"
        >
          <el-table-column label="序号" align="center" width="50px">
            <template slot-scope="scope">
              <el-badge value="危" class="item" :hidden="!scope.row.isRisky">
                <div style="height: 18px;">
                  {{scope.$index+1}}
                </div>
              </el-badge>
            </template>
          </el-table-column>
          <el-table-column prop="customerName" label="委托商名称" align="center"/>
          <!-- <el-table-column prop="customerSimple" label="委托商简称" align="center"/> -->
          <el-table-column label="委托商类型" align="center">
            <template slot-scope="scope">
              <div>
                <span v-for="(item,index) in scope.row.typeName">{{item}}<span v-if="index!==scope.row.typeName.length-1">、</span></span>
              </div>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="customerNatureName" label="公司性质" width="199" align="center"/> -->
          <el-table-column prop="telephone" label="联系电话" align="center"/>
          <el-table-column prop="directorName" label="对接人姓名" align="center"/>
          <!-- <el-table-column prop="address" label="详细地址" align="center"/> -->
          <el-table-column prop="examine" label="审核状态" align="center">
            <div slot-scope="scope">{{getState(scope.row.examine,scope.row.operationPower)}}</div>
          </el-table-column>
          <el-table-column prop="operationType" label="操作类型" align="center">
            <div slot-scope="scope">{{getOperatState(scope.row.operationType)}}</div>
          </el-table-column>
          <el-table-column label="操作" width="205" align="center">
            <template slot-scope="scope">
              <div style="align-items:center;padding-left: 10px">
                <el-button size="mini" class="searchBtn" type="primary" @click="detailClick(scope.row.id,scope.row.operationPower)">详情</el-button>
                <el-button v-if="scope.row.examine===1&&scope.row.operationPower==1" size="mini" type="primary" @click="enableClick(scope.row.id)">同意</el-button>
                <el-button v-if="scope.row.examine===1&&scope.row.operationPower==1" size="mini" type="danger" @click="disableClick(scope.row.id)">拒绝</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="paginationContainer">
        <span>共{{total}}条</span>
        <el-pagination
          background
          :page-sizes="[10, 20, 30, 40]"
          layout="sizes,prev, pager, next,jumper"
          :total="total"
          @size-change="contractSizeChange"
          @current-change="contractCurrentChange"
          @prev-click="contractCurrentChange"
          @next-click="contractCurrentChange"
        />
      </div>
    </div>
    <el-dialog title="详情委托公司" :visible.sync="detailDialogVisible" width='600px' center top="10vh" :close-on-click-modal="false">
      <div class="detail">
        <div class="baseInfo">
          <div class="baseInfoTitle">
            <div class="line"/>
            <span>基础信息</span>
            <p :style="getStyle(detailData.examine)">{{getState(detailData.examine)}}</p>
          </div>
          <div class="baseInfoContent">
            <div class="baseInfoContentItem">
              <span class="span1">委托商全称：</span>
              <span>{{detailData.customerName}}</span>
            </div>
            <div class="baseInfoContentItem">
              <span class="span1">委托商简称：</span>
              <el-badge value="危" class="item" :hidden="!detailData.isRisky">
                <div style="height: 18px;">
                  <span>{{detailData.customerSimple}}</span>
                </div>
              </el-badge>
            </div>
            <div class="baseInfoContentItem">
              <span class="span1">关键词：</span>
              <span>{{detailData.keyWord}}</span>
            </div>
            <div class="baseInfoContentItem">
              <span class="span1">客户类型：</span>
              <span v-for="(item,index) in detailData.typeName">{{item}}<span v-if="index!==detailData.typeName.length-1">、</span></span>
            </div>
            <!-- <div class="baseInfoContentItem specialItem">
              <div class="specialOne">
                  <span class="span1">公司性质：</span>
                <span>{{detailData.customerNatureName}}</span>
              </div>
              <div>
                <span class="span1">公司规模：</span>
                <span>{{detailData.customerScaleName}}</span>
              </div>
            </div>
            <div class="baseInfoContentItem specialItem">
              <div class="specialOne">
                <span class="span1">经营范围：</span>
                <span>{{detailData.businessScope}}</span>
              </div>
              <div>
                <span class="span1">注册资金：</span>
                <span>{{detailData.registeredCapital}}</span>
              </div>
            </div> -->
            <div class="baseInfoContentItem specialItem">
              <div class="specialOne">
                <span class="span1">联系电话：</span>
                <span>{{detailData.telephone}}</span>
              </div>
              <div>
                <span class="span1">联系邮箱：</span>
                <span>{{detailData.mailbox}}</span>
              </div>
            </div>
            <!-- <div class="baseInfoContentItem">
              <span class="span1">详细地址：</span>
              <span>{{detailData.address}}</span>
            </div> -->
            <div class="baseInfoContentItem specialItem">
              <div class="specialOne">
                <span class="span1">开户行：</span>
                <span>{{detailData.openAccountBank}}</span>
              </div>
              <div>
                <span class="span1">银行卡号：</span>
                <span>{{detailData.bankCardNumber}}</span>
              </div>
            </div>
            <div class='baseInfoContentItem specialItem'>
              <div class='specialOne'>
                <span class='span1'>业务来源：</span>
                <span>{{ detailData.businessSource }}</span>
              </div>
              <div>
                <span class='span1'>客户行业：</span>
                <span>{{ detailData.customerIndustry }}</span>
              </div>
            </div>
            <div v-for="item in detailData.person">
              <div class="baseInfoContentItem specialItem">
                <div class="specialOne">
                  <span class="span1">对接人姓名：</span>
                  <span>{{item.name}}</span>
                </div>
                <div>
                  <span class="span1">对接人手机：</span>
                  <span>{{item.tell}}</span>
                </div>
              </div>
              <div class="baseInfoContentItem">
                <span class="span1">对接人职位：</span>
                <span>{{item.position}}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="baseInfo">
          <div class="baseInfoTitle">
            <div class="line"/>
            <span>附件信息</span>
          </div>
          <div class="attachment" v-if="detailData.attachData &&detailData.attachData.length>0 ">
            <div v-for="item in detailData.attachData" class="attachmentItem">
              <span style="text-decoration: underline;cursor: pointer;" @click="imgClick(item.url,item.name)">{{item.name}}</span>
              <span>{{item.time}}</span>
            </div>
          </div>
          <div class="attachment" v-else> 暂无附件信息 </div>
        </div>
        <div class="baseInfo">
          <div class="baseInfoTitle">
            <div class="line"/>
            <span>审核信息</span>
          </div>
          <steps :step-data="stepData" :step-state="stepState"/>
        </div>
        <div class="baseInfo" v-if="detailData.operationPower===1 && detailData.examine===1">
          <div class="baseInfoTitle">
            <div class="line"/>
            <span>操作</span>
          </div>
          <div class="baseInfoContentItem">
            <div style="display: flex;margin:10px 20px 0 15px;">
              <span class="span1" style="width: 70px;"><span style="color:red">*</span>原因：</span>
              <el-input
                type="textarea"
                :style="'width:100%'"
                v-model="remark"
                placeholder="请填写同意/拒绝原因"
                autocomplete="off"
                size="small"
              />
            </div>
          </div>
        </div>
        <div style="display: flex;align-items: center;justify-content: center" v-if="detailData.operationPower===1 && detailData.examine===1">
          <el-button size="mini" type="primary" @click="agreeClick">同意</el-button>
          <el-button size="mini" type="danger" @click="refusedClick">拒绝</el-button>
        </div>
      </div>
    </el-dialog>
    <el-dialog :title="reasonTitle" :visible.sync="reasonVisible" width='550px' center :close-on-click-modal="false" top="30vh">
      <div class="reasonContainer">
        <div style="display: flex;padding-bottom: 20px;">
          <span class="span1" style="width: 70px;"><span style="color:red">*</span>原因：</span>
          <el-input
            type="textarea"
            style="width:100%;"
            v-model="reason"
            placeholder="请填写同意/拒绝原因"
            autocomplete="off"
            size="small"
          />
        </div>
        <div class="reasonBtn">
          <el-button size="mini" class="searchBtn" type="primary" @click="reasonClick">确认</el-button>
          <el-button size="mini" class="resetBtn" type="danger" @click="reasonVisible=false">取消</el-button>
        </div>
      </div>
    </el-dialog>
    <el-dialog center title="附件详情" :visible.sync="imgDialogVisible" width="200px;" append-to-body>
      <img style="width:100%;object-fit:cover" :src="dialogImageUrl" alt="">
    </el-dialog>
  </div>
</template>

<script>
import steps from "@/components/steps";
import {
  customerExaminePageList,
  customerExamineDetail,
  customerExamineReviewSubmit,
} from "@/service/audit"
import {customerNature, customerTypeSelectList} from "@/service/basicfile";
import {selectListBySourceId} from "@/service/getData";
import {baseImgUrl} from "@/config/env";

export default {
  components: {
    steps,
  },
  data() {
    return {
      entrustIpt:'',
      typeIpt:'',
      enterIpt:'',
      operationIpt:'',
      stateIpt:'',
      stateOption:[
        {value:'',label:'全部',},
        {value:1,label:'待审核'},
        {value:2,label:'已通过'},
        {value:3,label:'已拒绝'},
        {value:4,label:'已取消'},
        {value:5,label:'待完善'},
      ],
      operationOption:[
        {value:'',label:'全部',},
        {value:1,label:'新增'},
        {value:2,label:'信息变更'},
        {value:3,label:'终止合作'},
      ],
      enterOption:[],
      typeOption:[],
      page:1,
      size:10,
      total:0,
      tableLoad:false,
      TableDatas:[],
      detailDialogVisible:false,
      detailData:{},
      remark:'',
      stepData:[],
      reasonVisible:false,
      reasonTitle:'',
      reason:'',
      activeId:'',
      imgDialogVisible:false,
      dialogImageUrl:'',
      baseImgUrl: baseImgUrl+ '/',
    };
  },
  computed:{
    stepState(){
      return function(state){
        switch(state) {
          case '':
            return 'wait'
          case 'success':
            return 'success'
          case 'failure':
            return 'error'
        }
      };
    },
    getStyle() {
      return (val) => {
        switch (val) {
          case 2:
            return 'color: rgba(51, 136, 255, 1);'
          case 1:
            return 'color: rgba(249, 166, 6, 1)'
          case 3:
            return 'color:#F56C6C;'
          case 4:
            return 'color:#F56C6C;'
        }
      }
    },
    getState(){
      return function(state,operationPower){
        switch(true) {
          case operationPower ===0:
            return '已通过'
          case state ===1 &&operationPower ===1:
            return '待审核'
          case state ===2 &&operationPower ===1:
            return '已通过'
          case state ===3 &&operationPower ===1:
            return '已拒绝'
          case state ===4 &&operationPower ===1:
            return '已取消'
          case state ===5 &&operationPower ===1:
            return '待完善'
        }
      };
    },
    getOperatState(){
      return function(state){
        switch(state) {
          case 1:
            return '新增'
          case 2:
            return '信息变更'
          case 3:
            return '终止合作'
        }
      };
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    async init(){
      await this._customerExaminePageList();
      const res = await customerNature({'categoryCd': "consignor_nature"});
      if(res.status !== 0) this.$message.error(res.message);
      else this.enterOption=[{id:'',classaName:'全部'},...res.data];
      const res2 = await customerTypeSelectList();
      if(res2.status !== 0) this.$message.error(res2.message);
      else this.typeOption=[{id:'',type_name:'全部'},...res2.data];
    },
    async _customerExaminePageList(){
      this.tableLoad=true;
      const res = await customerExaminePageList(
        {
          customerName:this.entrustIpt,
          typeId:this.typeIpt,
          customerNatureId:this.enterIpt,
          operationType:this.operationIpt,
          examine:this.stateIpt,
          page:this.page,
          rows:this.size,
        }
      );
      this.tableLoad=false;
      if(res.status !== 0) this.$message.error(res.message);
      this.total=res.data.total;
      this.TableDatas=res.data.records.map(item=>{
        return{
          ...item,
          typeName:item.typeName?item.typeName.split(','):'',
        }
      });
    },
    async refusedClick() {
      this.remark = this.remark.trim();
      if (!this.remark) return this.$message.warning('请填写拒绝理由！');
      const res = await customerExamineReviewSubmit({
        id: this.activeId,
        auditOpinion: this.remark,
        reviewResult: 'REFUSE',
      })
      if (res.status !== 0) return this.$message.error(res.message);
      this.$message.success(res.message);
      this.detailDialogVisible = false;
      await this._customerExaminePageList();
    },
    async agreeClick(){
      this.remark=this.remark.trim();
      if(!this.remark) return this.$message.warning('请填写同意理由！');
      const res = await customerExamineReviewSubmit({
        id:this.activeId,
        auditOpinion:this.remark,
        reviewResult:'AGREE',
      })
      if(res.status !== 0) return this.$message.error(res.message);
      this.$message.success(res.message);
      this.detailDialogVisible=false;
      await this._customerExaminePageList();
    },
    contractSizeChange(sizes){
      this.size=sizes;
      this._customerExaminePageList();
    },
    contractCurrentChange(page){
      this.page=page;
      this._customerExaminePageList();
    },
    disableClick(id){
      this.$confirm('确认拒绝当前委托商申请吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.activeId=id;
        this.reason='';
        this.reasonTitle='拒绝原因';
        this.reasonVisible=true;
      }).catch(() => {});
    },
    imgClick(val,name){
      const arr =['.jpeg','.png','.jpg','.JPG','.gif','.PNG'];
      let str = name.substring(name.indexOf('.'));
      if(arr.indexOf(str)===-1) return this.$message.warning('只有图片类型附件才可以预览！')
      this.dialogImageUrl =this.baseImgUrl+ val
      this.imgDialogVisible = true
    },
    /**
     * 详情
     * @param id
     * @param operationPower 权限
     * @returns {Promise<void>}
     */
    async detailClick(id,operationPower){
      this.remark='';
      this.detailDialogVisible=true
      const res = await customerExamineDetail(id);
      if(res.status !== 0) this.$message.error(res.message);
      const arr1 =res.data.directorName.split(',');
      const arr2 =res.data.directorMobile.split(',');
      const arr3 =res.data.directorPost.split(',');
      const arr=[];
      arr1.forEach((item,index)=>arr.push({name:item,tell:arr2[index],position:arr3[index]}))
      this.detailData= {
        ...res.data,
        typeName:res.data.typeName.split(','),
        person:arr,
        attachData:[],
        operationPower:operationPower
      }
      this.detailData.attachData=res.data.attachmentList.map(item=>{
        return{
          name:item.attachmentName,
          time:item.uploadTime,
          url:item.attachmentGroup+'/'+item.attachmentPath,
        }
      })
      this.stepData = [];
      if(res.data.auditRecordList.length > 0) {
        res.data.auditRecordList.forEach((item) => {
          let status = '', temp = {}, text = '取消审核';
          if(item.status == 1) {text = '发起';}
          if(item.status == 0) {text = '重新发起';}
          if(item.status == 3) {
            status = 'failure', text = '拒绝';
            temp = {'title':item.deptName+' '+item.auditorName+' '+text,'time':item.createTime,'state':status,'remark':item.opinion}
          }
          else if(item.status == 2) {
            status = 'success', text = '同意';
            temp = {'title':item.deptName+' '+item.auditorName+' '+text,'time':item.createTime,'state':status,'remark':item.opinion}
          }
          else {
            temp = {'title':item.auditorName+' '+text,'time':item.createTime,'state':status,'remark': ''}
          }
          this.stepData.push(temp);
        })
      }
    },
    searchBtn(){
      this.page = 1;
      this._customerExaminePageList();
    },
    resetBtn(){
      this.entrustIpt='';
      this.typeIpt='';
      this.enterIpt='';
      this.operationIpt='';
      this.stateIpt='';
    },
    enableClick(id){
      this.$confirm('确认同意当前委托商申请吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.activeId=id;
        this.reason='';
        this.reasonTitle='同意原因';
        this.reasonVisible=true;
      }).catch(() => {});
    },
    async reasonClick(){
      this.reason=this.reason.trim();
      if(!this.reason) return this.$message.warning(this.reasonTitle==='同意原因'?'请填写同意原因！':'请填写拒绝原因!');
      const res = await customerExamineReviewSubmit({
        id:this.activeId,
        auditOpinion:this.reason,
        reviewResult:this.reasonTitle==='同意原因'?'AGREE':'REFUSE',
      })
      if(res.status !== 0) return this.$message.error(res.message);
      this.$message.success(res.message);
      this.reasonVisible=false;
      await this._customerExaminePageList();
    },
  },
};
</script>



<style lang="scss" scoped>
.mainContainer{
  width:100%;
  padding:20px 15px 0 25px;
  background-color: #fff;
  .line{
    width: 12px;
    height: 32px;
    background-color: rgba(51, 84, 131, 100);
    margin-right: 10px;
  }
  .line +span{
    font-size: 16px;
    color: rgba(51, 84, 131, 100);
    font-weight: 600;
  }
  .nav{
    width:100%;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    &Container{
      width:200px;
      display: flex;
      align-items: center;
      margin-right: 5px;
      margin-bottom: 5px;
      p{
        font-size: 14px;
        color: rgba(16, 16, 16, 100);
      }
    }
    &Btn{
      display: flex;
      align-items: center;
      margin-bottom: 5px;
    }
    ::v-deep {
      label.el-form-item__label {
        font-weight: 500;
        color: #101010;
      }
    }
  }
  .content{
    display: flex;
    flex-direction: column;
    align-items: center;
    .tableContainer{
      margin-top: 30px;
      margin-bottom: 25px;
      width: 100%;
      ::v-deep{
        .el-badge__content{
          top: 4px !important;
          right: 1px !important;
        }
        .el-badge__content{
          background-color: #F56C6C !important;
        }
        .el-table .cell {
          padding: 0;
        }
        .el-table th{
          padding: 0;
        }
        .el-table td{
          padding: 0;
        }
      }
    }
    .paginationContainer{
      margin-right: auto;
      display: flex;
      align-items: center;
      margin-bottom: 20px;
      span{
        font-size: 13px;
      }
    }
  }
  .detail{
    width: 100%;
    padding: 10px 0 20px 20px;
    max-height:80vh;
    overflow: auto;
    .baseInfo{
      display: flex;
      flex-direction: column;
      .attachment{
        display: flex;
        flex-direction: column;
        padding-top: 10px;
        &Item{
          width:80%;
          margin-bottom: 10px;
          margin-left:30px;
          display: flex;
          align-items: center;
          justify-content:space-between;
          span{
            color: #969696;
            font-size:14px;
          }
        }
      }
      &Title{
        display:flex;
        align-items:flex-end;
        p{
          font-weight: 700;
          font-size: 14px;
          color: rgba(51, 136, 255, 1);
          margin-left: 10px;
        }
      }
      &Content{
        display:flex;
        flex-direction: column;
        justify-content: space-between;
        padding:20px 23px 0 23px;
        &Item{
          margin-bottom: 20px;
          .span1{
            font-weight: 700;
          }
          span{
            font-size: 14px;
          }
          .specialOne{
            width:50%;
          }
        }
        .specialItem{
          display:flex;
        }
      }
    }
    .operation{
      display: flex;
      flex-direction: column;
      ::v-deep{
        .el-table td, .el-table th{
          padding:0;
        }
        .cell{
          font-size: 10px;
          padding:0;
        }
      }
      &Title{
        display:flex;
        align-items:flex-end;
        p{
          font-weight: 700;
          font-size: 14px;
          color: rgba(51, 136, 255, 1);
          margin-left: 10px;
        }
      }
      &Table{
        width:100%;
        margin-top: 10px;
        padding: 0 20px;
      }
    }
  }
  .reasonContainer{
    width:100%;
    padding: 20px 30px;
    ::v-deep{
      .el-textarea__inner{
        min-height: 100px!important;
      }
    }
    .reasonBtn{
      width: 100%;
      display: flex;
      align-items: center;
      justify-content:flex-end;
    }
  }
  .company{
    width:100%;
    padding: 20px 10px;
    ::v-deep{
      .el-form-item__label{
        font-weight: 700;
      }
      .el-input__inner{
        border: none;
      }
      .el-form-item__label{
        padding:0;
      }
      .el-form-item__content{
        position: relative;
      }
    }
    hr{
      margin: 0;
      position: absolute;
      width: 100%;
      bottom: 5px;
    }
    .btnContainer{
      width:100%;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 20px;
      button{
        margin: 0 15px;
      }
    }
  }
  ::v-deep{
    .el-table th>.cell{
      font-weight: 700!important;
    }
  }
}
::v-deep{
  .el-dialog__header {
    padding: 9px 20px 9px;
    background: #335483;
  }
  .el-dialog__title {
    line-height: 24px;
    font-size: 14px;
    color: #FFFFFF;
  }
  .el-dialog__headerbtn{
    top:9px;
  }
  .el-dialog__headerbtn .el-dialog__close {
    color: #fff;
    font-size: 25px;
  }
  .el-dialog__body {
    padding: 0;
  }
}
</style>
